import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Deletes a tag from a mailing list.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingListId - The ID of the mailing list from which the tag will be deleted.
 * @param tagId - The ID of the tag to delete from the mailing list.
 * @returns A promise that resolves to the operation result.
 * @throws Throws an error if either `mailingListId` or `tagId` is not provided, or if the request fails.
 */
export const deleteMailingListTag = async (instance: KyInstance, mailingListId?: number, tagId?: number) => {
  try {
    if (isNotDefined(mailingListId) || isNotDefined(tagId)) {
      throw new Error('Mailing List ID and Tag ID must be provided to delete a mailing list tag.');
    }

    return await instance
      .delete<OperationResult>(
        formatString(Uri.mailingList.deleteMailingListTag, mailingListId.toString(), tagId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
